import smartDate from '@qrohlf/smart-date'
import {withoutTZOffset} from 'lib/dateUtils'

export const getTimeSpanStr = (event) => {
  const eventHasEndDate = !!event.endsOn
  const isAllDay = event.allDay
  let starting = isAllDay ? event.startsOn : withoutTZOffset(event.startsAt)
  let ending = isAllDay ? (event.endsOn || event.startsOn) : withoutTZOffset(event.endsAt || event.startsAt)

  return smartDate(eventHasEndDate ? [starting, ending] : starting)
}
